import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';

export default function annotationReducer(
	state = initialstate.openDocumentReviewNoteCount,
	action
) {
	switch (action.type) {
		case types.GET_OPEN_DOCUMENT_NOTES:
			if (action.response) {
				if (action.response.allOpenDocumentNotesCount === 0) {
					return '' || initialstate.openDocumentReviewNoteCount;
				} else {
					return action.response.allOpenDocumentNotesCount || state;
				}
			}
			break;
		default:
			return state;
	}
}
